module.exports = __webpack_public_path__ + "img/ico-feed.aa9f9122.svg";